"use client";

import { useEffect, useState } from "react";
import { Menu, X, Instagram, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-6">
        <div className="h-6 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-6 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-6 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-6 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-6 w-16 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      <NavigationMenu className="hidden md:flex" viewport={false}>
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild className="hover:!bg-transparent focus:!bg-transparent relative group px-4 py-2">
                <Link to={item.href || "#"}>
                  <span className="relative">
                    {item.label}
                    <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                  </span>
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-background/95 backdrop-blur-md border-t border-white/10 shadow-medium">
          <nav className="container mx-auto px-4 py-6 flex flex-col gap-4">
            {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="relative group py-2 text-base" onClick={() => setMobileMenuOpen(false)} data-index={i}>
                <span className="relative">
                  {item.label}
                  <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                </span>
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Encabezado() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="encabezado" className={`dark bg-background text-foreground sticky top-0 z-50 w-full bg-background/60 backdrop-blur-xl border-b border-white/10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-[65px]" : "h-[90px]"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        <Link to="/HomePage#" className="flex items-center hover:opacity-80 transition-opacity">
          <img src="https://bodegajulian.es/wp-content/uploads/2026/02/Logo-Bodega-Julian-Cuadrado.png" alt="Bodega Julian" className="!h-[80px]" />
        </Link>

        <div className="flex items-center gap-6">
          <MenuProvider menu_id="38" className="flex items-center">
            <HeaderMenuConsumer />
          </MenuProvider>

          <div className="flex items-center gap-3">
            <Link to="https://instagram.com" newTab aria-label="Instagram" className="text-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
              <Instagram className="size-5" />
            </Link>
            <Link to="https://facebook.com" newTab aria-label="Facebook" className="text-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)]">
              <Facebook className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </header>;
}